export const PROFILE_MAX_AGE = 120;

export const PROFILE_BIRTH_DATE_LENGTH = 10;

export const PROFILE_BIRTH_DATE_DAY_LENGTH = 2;

export const PROFILE_BIRTH_DATE_MONTH_LENGTH = 2;

export const PROFILE_BIRTH_DATE_YEAR_LENGTH = 4;

export const PROFILE_BIRTH_DATE_MAX_DAY = 31;

export const PROFILE_BIRTH_DATE_MAX_MONTH = 12;

export const PROFILE_BIRTH_DATE_FORMAT = /^(\d{2})\.(\d{2})\.(\d{4})$/;

export const PROFILE_BIRTH_DATE_ISO_FORMAT = /^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/;

export const PROFILE_BIRTH_DATE_SEPARATOR = '.';
